export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";